import React from "react";
import { node, string } from "prop-types";
import Table, { Tbody, Td, Tr } from "../Table";
import { Col, Container, Row } from "../../../Grid";
import Heading from "../../../Heading";
import Button from "../../../Button";
import Paragraph from "../../../Paragraph";

export const VectorPageContainer = ({ children }) => {
	return <Container spacing={{ my: 20 }}>{children}</Container>;
};

VectorPageContainer.propTypes = {
	children: node.isRequired,
};

export const VectorPageTitle = ({ children }) => {
	return (
		<Row utility={{ justify: "center" }}>
			<Col sm={12} md={8} lg={7}>
				<Heading Tag="h2" sx={{ fontSize: "xl", textAlign: "center" }}>
					{children}
				</Heading>
			</Col>
		</Row>
	);
};

VectorPageTitle.propTypes = {
	children: node.isRequired,
};

export const VectorPageSubTitle = ({ children }) => {
	return (
		<Row utility={{ justify: "center" }}>
			<Col sm={12} md={8} lg={6}>
				<Paragraph sx={{ fontSize: "l" }}>{children}</Paragraph>
			</Col>
		</Row>
	);
};

VectorPageSubTitle.propTypes = {
	children: node.isRequired,
};

export const VectorPageListWrapper = ({ children }) => {
	return (
		<Row utility={{ justify: "center" }}>
			<Col sm={12} md={8} lg={6}>
				<ol className="mt-10">{children}</ol>
			</Col>
		</Row>
	);
};

VectorPageListWrapper.propTypes = {
	children: node.isRequired,
};

export const VectorPageListItem = ({ children }) => {
	return <li className="mt-5">{children}</li>;
};

VectorPageListItem.propTypes = {
	children: node.isRequired,
};

export const VectorPageTryButtonWrapper = ({ children }) => {
	return (
		<Row utility={{ justify: "center" }}>
			<Col sm={12} md={8} lg={6} spacing={{ mt: 10 }} sx={{ textAlign: "center" }}>
				{children}
			</Col>
		</Row>
	);
};

VectorPageTryButtonWrapper.propTypes = {
	children: node.isRequired,
};

export const VectorPageTryButton = ({ href = "/try-snapgene/", children, ...props }) => {
	return (
		<Button.Link href={href} size="s" {...props}>
			{children}
		</Button.Link>
	);
};

VectorPageTryButton.propTypes = {
	href: string,
	children: node.isRequired,
};

export const VectorPageTable = ({ children }) => {
	return (
		<Row utility={{ justify: "center" }}>
			<Col sm={12} md={8} lg={6} spacing={{ mt: 10 }}>
				<Table isBottomBorderedStriped>
					<Tbody>{children}</Tbody>
				</Table>
			</Col>
		</Row>
	);
};

VectorPageTable.propTypes = {
	children: node.isRequired,
};

export const VectorPageTableItemWrapper = ({ children }) => {
	return <Tr>{children}</Tr>;
};

VectorPageTableItemWrapper.propTypes = {
	children: node.isRequired,
};

export const VectorPageTableItem = ({ children }) => {
	return <Td spacing={{ py: 2, px: 4 }}>{children}</Td>;
};

VectorPageTableItem.propTypes = {
	children: node.isRequired,
};

export const VectorPageParagraphWrapper = ({ children }) => {
	return (
		<Row utility={{ justify: "center" }}>
			<Col sm={12} md={8} lg={7} spacing={{ mt: 10 }}>
				{children}
			</Col>
		</Row>
	);
};

VectorPageParagraphWrapper.propTypes = {
	children: node.isRequired,
};

export const VectorPageParagraph = ({ children, ...props }) => {
	return <Paragraph {...props}>{children}</Paragraph>;
};

VectorPageParagraph.propTypes = {
	...Paragraph.propTypes,
	children: node.isRequired,
};

export const VectorPageTabWrapper = ({ children }) => {
	return (
		<Row utility={{ justify: "center" }}>
			<Col sm={12} md={10} spacing={{ mt: 10 }}>
				{children}
			</Col>
		</Row>
	);
};

VectorPageTabWrapper.propTypes = {
	children: node.isRequired,
};

export const VectorPageImageWrapper = ({ children }) => {
	return (
		<Row utility={{ justify: "center" }}>
			<Col sm={12} md={10} lg={10} spacing={{ my: 15 }}>
				{children}
			</Col>
		</Row>
	);
};

VectorPageImageWrapper.propTypes = {
	children: node.isRequired,
};

export const VectorPageVideoContainer = ({ children }) => {
	return (
		<Row utility={{ justify: "center" }}>
			<Col sm={12} md={8} lg={6} spacing={{ mt: 10 }} sx={{ textAlign: "center" }}>
				{children}
			</Col>
		</Row>
	);
};

VectorPageVideoContainer.propTypes = {
	children: node.isRequired,
};

export const VectorPageContactUs = ({ children }) => {
	return (
		<Container spacing={{ mb: 20 }}>
			<Row utility={{ justify: "center" }}>
				<Col sm={12}>
					<Paragraph sx={{ textAlign: "center" }}>{children}</Paragraph>
				</Col>
			</Row>
		</Container>
	);
};

VectorPageContactUs.propTypes = {
	children: node.isRequired,
};
